import { PATHS } from "../utils/Constant";
import { fetchRS } from "../utils/fetchRS";

export const reporteGeneral1 = (body: { [key: string]: any }, type = 'json', reporte: string) => {
  if (reporte === PATHS.REPORTES.CONSOLIDADO_PROVEEDOR) {
    return fetchRS(`${process.env.REACT_APP_API_URL}/reportes/consolidado-proveedor/${type}`, {
      method: 'POST',
      objectBody: body
    });
  }
  return fetchRS(`${process.env.REACT_APP_API_URL}/reportes/pesos-provedores-x-dias/${type}`, {
    method: 'POST',
    objectBody: body
  });

}

export const litrosPorMeses = (body: { [key: string]: any }, type = 'json') => {
  return fetchRS(`${process.env.REACT_APP_API_URL}/reportes/litros-por-meses/${type}`, {
    method: 'POST',
    objectBody: body
  });
}

export const payDriversByDates = (body: { [key: string]: any }, type = 'json', reporte: string) => {
  if (reporte === PATHS.REPORTES.CONSOLIDADO_CONDUCTOR) {
    return fetchRS(`${process.env.REACT_APP_API_URL}/reportes/conductores-por-fechas/${type}`, {
      method: 'POST',
      objectBody: body
    });
  }
  return fetchRS(`${process.env.REACT_APP_API_URL}/reportes/extracto-d-conductores/${type}`, {
    method: 'POST',
    objectBody: body
  });

}

export const getHomeInfo = () => {
  return fetchRS(`${process.env.REACT_APP_API_URL}/reportes/home-info`);
}

